 
import HeaderStyles from "./Header.module.scss";

//  function Header(props){
//     console.log(props);
//     const{categories,text}=props
//     return(
//         <div className="header">
//             <h1>Header</h1>
//         </div>

//     )
//  }

//  export default Header;

 function Header({categories, text}){
    console.log(text);
    return(
        <div className={HeaderStyles.header}>
            <h1>{text}</h1>
            <div className={HeaderStyles.btns}>
              {
              categories.map((item)=>(
              <button key={item}>{item}</button>
              
              
              ))}  
            </div>
        </div>
       

    )
 }

 export default Header;